import React from 'react';
import Plot from 'react-plotly.js';


function About() {
    const data = [
        {
          x: [1, 2, 3, 4, 5],
          y: [1, 4, 9, 16, 25],
          type: 'scatter',
          mode: 'markers',
          marker: { color: 'blue' },
        },
      ];
    
      const layout = {
        width: 300,
        height: 250,
        title: 'Scatter Plot',
        xaxis: { title: 'X-axis' },
        yaxis: { title: 'Y-axis' },
      };
    
      return (
        <div>
          <h3>Scatter Plot</h3>
          <Plot data={data} layout={layout} />
        </div>
      );
}

export default About;